/**
 * @generated SignedSource<<14fb0f06af81246962d826ebdd759bb3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatMessageFlowNodeKind = "TEXT" | "IMAGE" | "SUBMIT" | "REPLY" | "%future added value";
export type ChatMessageKind = "TEXT" | "IMAGE" | "SUBMIT" | "%future added value";
export type ChatMessageReplyGroupKind = "TEXT_BOX" | "RADIO_BUTTON" | "CHECK_BOX" | "SELECT_BOX" | "TEXT_AREA" | "%future added value";
export type ChatMessageReplyKind = "CUSTOM_TEXT" | "API" | "OPTION" | "NAME" | "%future added value";
export type ChatbotActionKind = "BUTTON_CLICK" | "DURATION" | "%future added value";
export type ChatbotBotKind = "FORM" | "QUESTION" | "FORM_AND_QUESTION" | "QUESTION_AND_FORM" | "%future added value";
export type ChatbotColorKind = "DEFAULT" | "GRAY" | "BLACK" | "RED" | "BLUE" | "GREEN" | "YELLOW" | "ORANGE" | "PINK" | "DARK_PINK" | "CUSTOM_COLOR" | "%future added value";
export type ChatbotDisplayKind = "RIGHT_BOTTOM" | "LEFT_BOTTOM" | "RIGHT_TOP" | "LEFT_TOP" | "%future added value";
export type ChatbotSubmitMethodKind = "GET" | "POST" | "%future added value";
export type DistributionStatus = "ACTIVE" | "INACTIVE" | "%future added value";
export type UpdateChatbotInput = {
  clientMutationId?: string | null;
  actionKind?: ChatbotActionKind | null;
  botImageAlt?: string | null;
  botImage?: File | Blog | null;
  botKind?: ChatbotBotKind | null;
  botTextColor?: string | null;
  botBackgroundColor?: string | null;
  chatbotId: string;
  colorKind?: ChatbotColorKind | null;
  chatFormColor?: string | null;
  clientTextColor?: string | null;
  clientBackgroundColor?: string | null;
  displayKind?: ChatbotDisplayKind | null;
  honeycombCode?: string | null;
  name?: string | null;
  notFoundMessage?: string | null;
  openButtonText?: string | null;
  openButtonImage?: File | Blog | null;
  status?: DistributionStatus | null;
  title?: string | null;
  titleTextColor?: string | null;
  timing?: number | null;
  toFormButtonImage?: File | Blog | null;
  weight?: number | null;
  submitMethodKind?: ChatbotSubmitMethodKind | null;
  xOffset?: number | null;
  xOffsetUnit?: string | null;
  yOffset?: number | null;
  yOffsetUnit?: string | null;
  windowColor?: string | null;
  questionCsv?: File | Blog | null;
  questionFinishMessage?: string | null;
  chatMessageNodes: ReadonlyArray<ChatMessageFlowNodeInput>;
  chatMessageEdges: ReadonlyArray<ChatMessageFlowEdgeInput>;
  chatMessageReplies?: ReadonlyArray<ChatMessageReplyInput> | null;
  chatbotApiResults?: ReadonlyArray<ChatbotApiResultInput> | null;
};
export type ChatMessageFlowNodeInput = {
  nodeId: string;
  kind: ChatMessageFlowNodeKind;
  x: number;
  y: number;
  chatMessage: ChatMessageInput;
  chatMessageReplyGroup?: ChatMessageReplyGroupInput | null;
};
export type ChatMessageInput = {
  id?: string | null;
  messageType: ChatMessageKind;
  message?: string | null;
  submitUrl?: string | null;
  isInheritQuery: boolean;
  hasReply: boolean;
  saveReply: boolean;
  displaySpeed: number;
  transferReply: boolean;
  chatMessageImage?: ChatMessageImageInput | null;
};
export type ChatMessageImageInput = {
  id?: string | null;
  alt?: string | null;
  linkUrl?: string | null;
  image?: File | Blog | null;
  isInheritQuery?: boolean | null;
};
export type ChatMessageReplyGroupInput = {
  id?: string | null;
  replyGroupType: ChatMessageReplyGroupKind;
  label?: string | null;
  divergingPoint: boolean;
};
export type ChatMessageFlowEdgeInput = {
  edgeId: string;
  source: number;
  target: number;
};
export type ChatMessageReplyInput = {
  id?: string | null;
  parentNodeId: string;
  replyNodeId: string;
  replyType: ChatMessageReplyKind;
  label?: string | null;
  name: string;
  value?: string | null;
  regularExpression?: string | null;
  placeholder?: string | null;
  errorMessage?: string | null;
  apiAction?: string | null;
};
export type ChatbotApiResultInput = {
  replyIndex: number;
  nextMessageNumber: number;
  result: string;
};
export type UpdateOriginalChatbotInput = {
  clientMutationId?: string | null;
  chatbotGroupId: string;
  status?: DistributionStatus | null;
  weight?: number | null;
};
export type ChatbotPatternEditScreenContainer_Mutation$variables = {
  input: UpdateChatbotInput;
  originalInput: UpdateOriginalChatbotInput;
  withOriginal: boolean;
};
export type ChatbotPatternEditScreenContainer_MutationVariables = ChatbotPatternEditScreenContainer_Mutation$variables;
export type ChatbotPatternEditScreenContainer_Mutation$data = {
  readonly updateOriginalChatbot?: {
    readonly chatbot: {
      readonly id: string;
      readonly weight: number | null;
    };
  } | null;
  readonly updateChatbot: {
    readonly chatbot: {
      readonly slug: string;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ChatbotPatternEditScreenContainer_chatbot">;
    };
  } | null;
};
export type ChatbotPatternEditScreenContainer_MutationResponse = ChatbotPatternEditScreenContainer_Mutation$data;
export type ChatbotPatternEditScreenContainer_Mutation = {
  variables: ChatbotPatternEditScreenContainer_MutationVariables;
  response: ChatbotPatternEditScreenContainer_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "originalInput"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "withOriginal"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "weight",
  "storageKey": null
},
v3 = {
  "condition": "withOriginal",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "originalInput"
        }
      ],
      "concreteType": "UpdateOriginalChatbotPayload",
      "kind": "LinkedField",
      "name": "updateOriginalChatbot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Chatbot",
          "kind": "LinkedField",
          "name": "chatbot",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v4 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInheritQuery",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coordinate",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "messageIndex",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nextMessageIndex",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v14 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "source",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "target",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatbotPatternEditScreenContainer_Mutation",
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "UpdateChatbotPayload",
        "kind": "LinkedField",
        "name": "updateChatbot",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Chatbot",
            "kind": "LinkedField",
            "name": "chatbot",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v1/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ChatbotPatternEditScreenContainer_chatbot"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChatbotPatternEditScreenContainer_Mutation",
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "UpdateChatbotPayload",
        "kind": "LinkedField",
        "name": "updateChatbot",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Chatbot",
            "kind": "LinkedField",
            "name": "chatbot",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatbotGroup",
                "kind": "LinkedField",
                "name": "chatbotGroup",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deliverKind",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Chatbot",
                    "kind": "LinkedField",
                    "name": "originalChatbot",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "actionKind",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "botImageAlt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "botImageCache",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "botImageUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "botKind",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "botTextColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "botBackgroundColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "colorKind",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "chatFormColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientTextColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientBackgroundColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayKind",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "honeycombCode",
                "storageKey": null
              },
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notFoundMessage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "openButtonText",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "openButtonImageCache",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "openButtonImageUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "titleTextColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timing",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "toFormButtonImageCache",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "submitMethodKind",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "xOffset",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "xOffsetUnit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "yOffset",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "yOffsetUnit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "windowColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "questionCsvUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "questionFinishMessage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "toFormButtonImageUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatMessageFlowNode",
                "kind": "LinkedField",
                "name": "chatMessageFlowNodes",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ChatMessageFlowNodePosition",
                    "kind": "LinkedField",
                    "name": "position",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "x",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "y",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ChatMessage",
                    "kind": "LinkedField",
                    "name": "chatMessage",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "message",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isHasReply",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isSaveReply",
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isTransferReply",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displaySpeed",
                        "storageKey": null
                      },
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "submitUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ChatMessageImage",
                        "kind": "LinkedField",
                        "name": "chatMessageImage",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "image",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "alt",
                            "storageKey": null
                          },
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "imageUrl",
                            "storageKey": null
                          },
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "linkUrl",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ChatMessageReplyGroup",
                    "kind": "LinkedField",
                    "name": "replyGroup",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v6/*: any*/),
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "number",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "divergingPoint",
                        "storageKey": null
                      },
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ChatMessageReply",
                        "kind": "LinkedField",
                        "name": "replies",
                        "plural": true,
                        "selections": [
                          (v1/*: any*/),
                          (v6/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "errorMessage",
                            "storageKey": null
                          },
                          (v13/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "regularExpression",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "placeholder",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "replyNodeId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "apiAction",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ChatbotApiResult",
                            "kind": "LinkedField",
                            "name": "chatbotApiResults",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "nextMessageNumber",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "result",
                                "storageKey": null
                              },
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatMessageReplyFlowNode",
                "kind": "LinkedField",
                "name": "chatMessageReplyFlowNodes",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeLabel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "parentNode",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatMessageFlowEdge",
                "kind": "LinkedField",
                "name": "chatMessageFlowEdges",
                "plural": true,
                "selections": (v14/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatMessageReplyFlowEdge",
                "kind": "LinkedField",
                "name": "chatMessageReplyFlowEdges",
                "plural": true,
                "selections": (v14/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d56ee13ffa6d58b9be75130692260184",
    "id": null,
    "metadata": {},
    "name": "ChatbotPatternEditScreenContainer_Mutation",
    "operationKind": "mutation",
    "text": "mutation ChatbotPatternEditScreenContainer_Mutation(\n  $input: UpdateChatbotInput!\n  $originalInput: UpdateOriginalChatbotInput!\n  $withOriginal: Boolean!\n) {\n  updateOriginalChatbot(input: $originalInput) @include(if: $withOriginal) {\n    chatbot {\n      id\n      weight\n    }\n  }\n  updateChatbot(input: $input) {\n    chatbot {\n      slug\n      id\n      ...ChatbotPatternEditScreenContainer_chatbot\n    }\n  }\n}\n\nfragment ChatbotPatternEditScreenContainer_chatbot on Chatbot {\n  id\n  chatbotGroup {\n    id\n    deliverKind\n    originalChatbot {\n      weight\n      id\n    }\n  }\n  actionKind\n  botImageAlt\n  botImageCache\n  botImageUrl\n  botKind\n  botTextColor\n  botBackgroundColor\n  colorKind\n  chatFormColor\n  clientTextColor\n  clientBackgroundColor\n  displayKind\n  honeycombCode\n  kind\n  name\n  notFoundMessage\n  openButtonText\n  openButtonImageCache\n  openButtonImageUrl\n  slug\n  status\n  title\n  titleTextColor\n  timing\n  toFormButtonImageCache\n  weight\n  submitMethodKind\n  xOffset\n  xOffsetUnit\n  yOffset\n  yOffsetUnit\n  windowColor\n  questionCsvUrl\n  questionFinishMessage\n  toFormButtonImageUrl\n  chatMessageFlowNodes {\n    nodeId\n    kind\n    position {\n      x\n      y\n    }\n    chatMessage {\n      id\n      kind\n      message\n      isHasReply\n      isSaveReply\n      isInheritQuery\n      isTransferReply\n      displaySpeed\n      coordinate\n      messageIndex\n      nextMessageIndex\n      submitUrl\n      chatMessageImage {\n        image\n        alt\n        id\n        imageUrl\n        isInheritQuery\n        linkUrl\n      }\n    }\n    replyGroup {\n      id\n      kind\n      label\n      number\n      divergingPoint\n      coordinate\n      replies {\n        id\n        kind\n        messageIndex\n        nextMessageIndex\n        errorMessage\n        label\n        name\n        value\n        regularExpression\n        placeholder\n        replyNodeId\n        apiAction\n        chatbotApiResults {\n          nextMessageNumber\n          result\n          id\n        }\n      }\n    }\n  }\n  chatMessageReplyFlowNodes {\n    nodeId\n    nodeLabel\n    parentNode\n    kind\n  }\n  chatMessageFlowEdges {\n    source\n    target\n  }\n  chatMessageReplyFlowEdges {\n    source\n    target\n  }\n}\n"
  }
};
})();

(node as any).hash = "5c70f54fd9fbd3486ede45e72f40172f";

export default node;
